module.exports = __webpack_public_path__ + "img/3_1.c2ab3b40.png";